/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

import React from 'react';
import { Container } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { decorate, observable, action, runInAction } from 'mobx';
import RolesList from './RolesList';
import UsersList from './UsersList';
import AuthenticationProvidersList from '@amzn/base-ui/dist/parts/authentication-providers/AuthenticationProvidersList';

const tabs = [
  { id: 'users', label: 'Users' },
  { id: 'roles', label: 'Roles' },
  { id: 'auth', label: 'Auth Providers' },
];

class User extends React.Component {
  constructor(props) {
    super(props);
    runInAction(() => {
      this.activeTab = 'users';
    });
  }

  handleTabChange = (tabId) => { this.activeTab = tabId; };

  render() {
    if (!this.props.userStore.cloneUser.isAdmin) {
      this.props.history.push('/');
    }

    return (
      <Container className="mt3 animated fadeIn">
        <div className="study-tabs" data-testid="users-table">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`study-tab${this.activeTab === tab.id ? ' active' : ''}`}
              onClick={() => this.handleTabChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        {this.activeTab === 'users' && <UsersList />}
        {this.activeTab === 'roles' && <RolesList />}
        {this.activeTab === 'auth' && <AuthenticationProvidersList embedded />}
      </Container>
    );
  }
}

decorate(User, {
  activeTab: observable,
  handleTabChange: action,
});

export default inject('userStore')(withRouter(observer(User)));
